export default {
  header: {
    notes: 'Header for order details pane',
    message: 'Order {{orderNumber}}',
  },
  generalInformation: {
    header: {
      notes: 'General information header',
      message: 'General information',
    },
  },
  additionalInformation: {
    header: {
      notes: 'Additional information header',
      message: 'Additional information',
    },
  },
  articles: {
    header: {
      notes: 'Header for the order articles section',
      message: 'Articles',
    },
  },
  invoice: {
    header: {
      notes: 'Header for the invoices section',
      message: 'Invoice {{invoiceNumber}}',
    },
  },
  tabs: {
    summaryInformation: {
      label: {
        notes: 'Label for summary information tab',
        message: 'Summary information',
      },
    },
    deliveryAndPaymentInformation: {
      label: {
        notes: 'Label for delivery and payment information tab',
        message: 'Delivery & payment information',
      },
    },
  },
};
